import React from "react";
import toast from "react-hot-toast";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import { tr } from "../../i18n";

function PrevNextPagination({ pagination, onBack, onNext }) {
  if (!pagination) return null;

  const totalPages = Math.max(Number(pagination.totalPages || 0), 1);
  const currentPage = Math.min(
    Math.max(Number(pagination.currentPage || 1), 1),
    totalPages
  );
  const totalItems = Number(pagination.totalItems || 0);
  const itemsPerPage = Number(pagination.itemsPerPage || 10);

  const startItem = totalItems === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  const disableBack = currentPage <= 1;
  const disableNext = currentPage >= totalPages;

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: "16px",
        padding: "12px 20px",
        fontFamily: "'Electrolize', sans-serif",
      }}
    >
      <span style={{ color: "#6B7280", fontSize: "13px", fontWeight: 400 }}>
        {startItem}–{endItem} {tr("of")} {totalItems}
      </span>

      <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <button
          disabled={disableBack}
          style={{
            height: "32px",
            width: "32px",
            borderRadius: "6px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "14px",
            border: "none",
            background: "transparent",
            color: disableBack ? "#D1D5DB" : "#374151",
            cursor: disableBack ? "not-allowed" : "pointer",
            transition: "color 0.15s ease",
          }}
          onClick={() => {
            if (currentPage > 1) onBack(currentPage - 1);
            else toast.error(tr("Underflow"));
          }}
          aria-label={tr("Previous page")}
        >
          <BsChevronLeft />
        </button>

        <span
          style={{
            color: "#374151",
            fontSize: "13px",
            fontWeight: 500,
            padding: "0 4px",
            userSelect: "none",
          }}
        >
          {currentPage} / {totalPages}
        </span>

        <button
          disabled={disableNext}
          style={{
            height: "32px",
            width: "32px",
            borderRadius: "6px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "14px",
            border: "none",
            background: "transparent",
            color: disableNext ? "#D1D5DB" : "#374151",
            cursor: disableNext ? "not-allowed" : "pointer",
            transition: "color 0.15s ease",
          }}
          onClick={() => {
            if (currentPage < totalPages) onNext(currentPage + 1);
            else toast.error(tr("Overflow"));
          }}
          aria-label={tr("Next page")}
        >
          <BsChevronRight />
        </button>
      </div>
    </div>
  );
}

export default PrevNextPagination;
